<template>
  <!-- Cabecera de las páginas interiores de las plantillas 2 a 5: el mismo marcado, cada plantilla la pinta a su manera -->
  <section class="n2-cabeza-pagina" :class="{ 'n2-cabeza-pagina--con-foto': !!media }">
    <figure v-if="media" class="n2-cabeza-pagina__foto">
      <video v-if="esVideo" :src="media" muted autoplay playsinline loop preload="metadata"></video>
      <img v-else :src="media" :alt="titulo" fetchpriority="high" :style="{ filter: filtro || undefined }" />
    </figure>
    <div class="n2-contenedor n2-cabeza-pagina__texto">
      <nav class="n2-migas" aria-label="breadcrumb">
        <NuxtLink :to="getLocalePath('/')">{{ tituloSeccion(NOTARIA, 'Inicio', $t) }}</NuxtLink>
        <template v-for="m in migas" :key="m.texto">
          <span aria-hidden="true">/</span>
          <NuxtLink v-if="m.to" :to="m.to">{{ m.texto }}</NuxtLink>
          <span v-else>{{ m.texto }}</span>
        </template>
      </nav>
      <h1 class="n2-cabeza-pagina__titulo">{{ titulo }}</h1>
      <p v-if="subtitulo" class="n2-cabeza-pagina__subtitulo">{{ subtitulo }}</p>
      <slot />
      <div v-if="boton?.Texto && boton?.Click" class="n2-cabeza-pagina__botones">
        <a :href="boton.Click" class="n2-boton n2-boton--acento n2-boton--grande">{{ boton.Texto }}</a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion } from '../../composables/useNotaria2'

const props = defineProps({
  titulo: { type: String, default: '' },
  subtitulo: { type: String, default: '' },
  /** Id de la imagen o vídeo del panel (cabecera de la sección, o la portada del servicio). */
  imagen: { type: String, default: '' },
  filtro: { type: String, default: '' },
  /** Botón de la cabecera de la sección (panel: Mostrar botón). */
  boton: { type: Object, default: null },
  /** Migas después de «Inicio»: [{ texto, to? }]. Por defecto, el título. */
  rastro: { type: Array, default: null },
})

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, getFile, $t, getLocalePath } = useUtils()

const media = computed(() => props.imagen ? imagenIDtoSRC(props.imagen) : '')
const esVideo = computed(() => getFile(props.imagen)?.type === 'video/mp4')
const migas = computed(() => props.rastro ?? [{ texto: props.titulo }])
</script>
